import RouteError from '@/components/ui/route-error';
import { createFileRoute } from '@tanstack/react-router';
import RecoverAccountFlow from '@/features/activation/components/recover-account-flow';

export const Route = createFileRoute('/recover-account')({
  component: RecoverAccountFlow,
  errorComponent: RouteError,
});
